import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconArrowRightLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.611 12.75H5.25a.726.726 0 0 1-.535-.216A.725.725 0 0 1 4.5 12c0-.213.072-.391.215-.534a.725.725 0 0 1 .535-.216h11.361L13.32 7.958a.706.706 0 0 1-.22-.523.77.77 0 0 1 .22-.531.765.765 0 0 1 .535-.24c.201-.006.38.07.535.224l4.478 4.48a.827.827 0 0 1 .256.632.828.828 0 0 1-.256.633l-4.479 4.478a.715.715 0 0 1-.53.22.751.751 0 0 1-.539-.235.783.783 0 0 1-.225-.527.699.699 0 0 1 .225-.527l3.292-3.292Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconArrowRightLine;
